import React from "react";
import CrudManager from "@/components/admin/CrudManager";

export default function GalleryAdmin() {
  return (
    <CrudManager
      title="Gallery"
      description="Upload and organise images shown in the gallery."
      endpoint="gallery"
      fields={[
        { name: "title", label: "Title / Caption", type: "text" },
        { name: "category", label: "Category", type: "select", options: ["Product", "Technology", "Lifestyle", "Installations", "Events"] },
        { name: "image", label: "Image", type: "image" },
        { name: "order", label: "Display Order", type: "number" },
        { name: "active", label: "Visible", type: "switch" },
      ]}
      columns={[
        { name: "image", label: "Image", type: "image" },
        { name: "title", label: "Title", type: "text" },
        { name: "category", label: "Category", type: "text" },
        { name: "active", label: "Status", type: "switch" },
      ]}
    />
  );
}
